/**
 * Check the length of a list of values or a string
 *
 * @param {string[] | string} values list of values to check the lenght of, or a string
 * @returns {number} length of the list
 */
function len(values: string[] | string) {
  if (values && Array.isArray(values)) {
    return values.length;
  } else if (values && typeof values === 'string') {
    return values.length;
  }
  return undefined;
}

export default len;
